import React from 'react'
import { BiHome, BiBookAlt } from 'react-icons/bi'
import { useSelector } from 'react-redux'
import styled from '../../utils/styled'
import { UserIcon } from './UserIcon'
import { ApplicationState } from '../../store'
import { Link } from './Link'
import { RouteType } from '../../types/routes'

const MobileBottomBarContainer = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 1000;
  width: 100%;
  height: 4.125rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0.5rem 1.5rem;
  background-color: ${({ theme }) => theme.colors.brand};

  @media (min-width: ${props => props.theme.breakpoints.sm}) {
    display: none;
  }
`

const HomeIcon = styled(BiHome)`
  font-size: ${props => props.theme.iconSizes.md};
`

const BookingIcon = styled(BiBookAlt)`
  font-size: ${props => props.theme.iconSizes.md};
`

const MobileBottomBar: React.FC = () => {
  const { isLoggedIn: isUserLoggedIn } = useSelector((state: ApplicationState) => state.user)

  return (
    <MobileBottomBarContainer>
      <Link to={RouteType.Home}>
        <HomeIcon />
      </Link>
      {isUserLoggedIn && (
        <Link to={RouteType.UserBookings}>
          <BookingIcon />
        </Link>
      )}
      <Link to={isUserLoggedIn ? RouteType.Profile : RouteType.Login}>
        <UserIcon />
      </Link>
    </MobileBottomBarContainer>
  )
}

export default MobileBottomBar
